export type SupportedLanguage = 'en' | 'ar' | 'es';
export type TextDirection = 'ltr' | 'rtl';

export interface LanguageConfig {
    code: SupportedLanguage;
    label: string;
    nativeLabel: string;
    locale: string;
    dir: TextDirection;
}

export const SUPPORTED_LANGUAGES: Record<SupportedLanguage, LanguageConfig> = {
    en: {
        code: 'en',
        label: 'English',
        nativeLabel: 'English',
        locale: 'en-US',
        dir: 'ltr',
    },
    ar: {
        code: 'ar',
        label: 'Arabic',
        nativeLabel: 'العربية',
        locale: 'ar-AE',
        dir: 'rtl',
    },
    es: {
        code: 'es',
        label: 'Spanish',
        nativeLabel: 'Español',
        locale: 'es-ES',
        dir: 'ltr',
    },
};

export const supportedLanguageCodes = Object.keys(SUPPORTED_LANGUAGES) as SupportedLanguage[];

export const normalizeLanguage = (value?: string | null): SupportedLanguage => {
    const normalized = String(value || '').trim().toLowerCase();
    if (normalized.startsWith('ar')) return 'ar';
    if (normalized.startsWith('es')) return 'es';
    return 'en';
};

export const applyDocumentLanguage = (language: string, forceDir?: TextDirection): void => {
    if (typeof document === 'undefined') return;

    const normalized = normalizeLanguage(language);
    const config = SUPPORTED_LANGUAGES[normalized];
    const dir = forceDir || config.dir;

    document.documentElement.lang = config.locale;
    document.documentElement.dir = dir;
    document.body?.classList.remove('lang-en', 'lang-ar', 'lang-es', 'dir-ltr', 'dir-rtl');
    document.body?.classList.add(`lang-${normalized}`, `dir-${dir}`);
};
